import React , { useState , useRef , useEffect }from 'react'

import { ApiCallPostClient  , ApiCallGetClient} from '../../ApiCall/ApiCallClient'

import { ApiCallGet } from '../../ApiCall/ApiCall';

import Select from 'react-select';

export default function CampainSetUp() {

    const [maxsms,setMaxSms] = useState( 16 ) 
    const [delay,setDelay] = useState( 10 )
    const [interDelay,setInterDelay] = useState( 1 )
    const [campSelected,setCampainSelected] = useState(null)
    const [theOptions,setTheOptions] = useState([])

    const selectRef = useRef(null)

    function onStop(){
        ApiCallPostClient('stop', {})
        .then( (response) => {
            console.log( response )

            if ( response === 'ok')
            {
                alert( "Campaña detenida correctamente")
            }
        } )
        .catch( (error) => {
            console.log( error )
        })
    }

    useEffect( () => {
        ApiCallGet('getcampains')
        .then( (response) => {
            console.log( response )

            var array = []

            for( var i = 0 ; i < response.length ; i++ ){
                array.push({ value : response[i].id, label : response[i].name , message : response[i].message })
            }
            
            setTheOptions( array )

        } )
        .catch( (error) => {
            console.log( error )
        })

        

    } , [] )

    function onMaxSmsChange( val )
    {
        setMaxSms( val.target.value )
    }
    
    function onDelayChange( val )
    {
        setDelay( val.target.value )
    }

    function onInterDelayChange( val )
    {
        setInterDelay( val.target.value )
    }


    function onSelectCampain( val )
    {
        console.log( "val = " + val.value )
        console.log( "label = " + val.label )

        setCampainSelected( val ) // Datos de la campaña seleccionada
    }

    

    function onSubmit(e)
    {
        e.preventDefault()

        if ( campSelected === null )
        {
            alert( "No se selecciono campaña")
            return ;
        }

        // Los otros dos campos tienen valores de default

        var body = {
            campain : campSelected.value ,
            message : theOptions[ campSelected.value  -1 ].message  ,
            nCalls : maxsms ,
            timer : delay ,
            interDelay : interDelay
        }


        console.log( "Vamos a setUp con body = " , body )

        ApiCallPostClient( 'setup' , body )
        .then( (response) => {
            console.log( response )

            if ( response === 'ok')
            {
                alert( "Campaña configurada correctamente")
                //selectRef.current.clearValue()
            }
        } )
        .catch( (error) => {
            console.log( error )
            alert( "Error al configurar campaña")
        })

    }

    // timer , nCalls

  return (
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

        < div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2 w-50'  id="page1" style={{margin : 'auto'}}>

            <h1>Digital Sms</h1>

            <h3>Iniciar Campaña</h3>

                <form onSubmit={onSubmit}>
                    <div className='row'>
                        <div className='col-8'>

                        <Select ref={selectRef}  options={theOptions} 
                            placeholder="Seleccione una campaña" onChange={onSelectCampain}/>  


                        </div>

                    </div>

                    <div className='row'>

                        <div className='col-8'>

                        <label className="form-label m-0" htmlFor="ncalls">MaxSms</label>
                            <input type="number" className="form-control" id="ncalls" min={2} 
                            value={maxsms} onChange={onMaxSmsChange} />

                        </div>

                    </div>

                    <div className='row'>

                        <div className='col-8'>

                            <label className="form-label m-0" htmlFor="timer">Dalay( segundos )</label>
                                <input type="number" className="form-control" id="timer" min={10} 
                                value={delay} onChange={onDelayChange} />


                        </div>

                    </div>

                    <div className='row'>

                        <div className='col-8'>

                            <label className="form-label m-0" htmlFor="interdelay">InterDalay( pasos )</label>
                                <input type="number" className="form-control" id="interdelay" min={0} 
                                value={interDelay} onChange={onInterDelayChange} />


                        </div>

                    </div>

                    <div className='row mt-1'>


                        <div className='col-3'>
                            <button type="submit"  className="btn btn-primary mt-5 button-3"  >Configurar</button> 
                        </div>

                        
                        <div className='col-3'>
                            <button type="button" onClick={onStop}  className="btn btn-primary mt-5 button-3"  >Detener</button> 
                        </div>


                    </div>

                </form>
            </div>

    </div>
  )
}
